export var SlateIdType;
(function (SlateIdType) {
    SlateIdType["NAVIGATION"] = "NAVIGATION";
    SlateIdType["PAGE"] = "PAGE";
    SlateIdType["SPACE"] = "SPACE";
    SlateIdType["POST"] = "POST";
    SlateIdType["MEMBER"] = "MEMBER";
    SlateIdType["APP"] = "APP";
})(SlateIdType || (SlateIdType = {}));
export class SlateIdUtil {
    static decode(slateId) {
        if (slateId &&
            slateId.length > 0 &&
            slateId.includes(SlateIdUtil.separator)) {
            const [type, id] = slateId.split(SlateIdUtil.separator);
            return {
                type: SlateIdType[type],
                id,
            };
        }
        return null;
    }
    static encode(slateId) {
        if (slateId.id && slateId.id.length > 0 && slateId.type) {
            return `${slateId.type}${SlateIdUtil.separator}${slateId.id}`;
        }
        return null;
    }
}
SlateIdUtil.separator = '::';
//# sourceMappingURL=slate-id.util.js.map